<style src="css/music.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <div class="topbar-wrapper">
            <div class="topbar">
                <span class="back" @click="back"></span>
                放松助眠
            </div>
        </div>
        <audio ref="player" :src="fileUrl+musicDetail.sourceUrl" id="main-audio" autoplay></audio>
        <div class="musicBg">
            <img :src="EnvUrl+musicDetail.picUrl" alt="" v-if="musicDetail.picUrl != undefined">
            <div class="musicBox">
                <div class="con-p">

                </div>
            </div>
            <div class="progressBox">
                {{cTime}}
                <div class="progress" ref="runfatbar">
                    <div class="greenbar" ref="runbar">
                        <span class="yuan" draggable="true"></span>
                    </div>
                </div>
                {{dTime}}
            </div>
            <div class="playBox">
                <div class="loop"></div>
                <div class="prev" @click="prev"></div>
                <div class="playBtn" @click="playMusic" v-if="play"></div>
                <div class="pauseBtn" @click="pauseMusic" v-else></div>
                <div class="next" @click="next"></div>
                <div class="catalog" @click="catalogStatus=true"></div>
            </div>
        </div>
        <div class="mask"  v-if="catalogStatus" @click="catalogStatus=false">
            <div class="catalogBox">
                <div class="catalogTitle">播放列表 <div class="close" @click="catalogStatus=false"></div></div>
                <div class="catalogItem" :class="{active:index===i}" v-for="(item,i) in musicList" @click.stop="select(i)">
                    {{item.name}}
                    <div class="playStyle" v-if="index===i"></div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'



    import lyrics from '../lyrics'


    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                fileUrl: `https://cdn.ysqingxin.com/`,
                catalogStatus: false,
                musicId:'',
                musicDetail: {},
                musicList: [],
                index: 0,
                cTime: `00:00`,
                dTime: ``,
                play: false,
                // lyric: "[00:00.000] 作曲 : 殇小谨[00:00.016] 作词 : 假寐[00:00.50]编曲：Morri3on(喬凡三)[00:01.50]一想到你我就[00:02.881]wu~~~~[00:04.766]空恨别梦久[00:07.395]wu~~~~[00:09.552]烧去纸灰埋烟柳[00:13.329][00:33.091]于鲜活的枝丫[00:35.446]凋零下的无暇[00:37.794]是收获谜底的代价[00:40.591][00:41.647]余晖沾上 远行人的发[00:44.878]他洒下手中牵挂[00:48.884]于桥下[00:50.956]前世迟来者~~~（擦肩而过）[00:54.039]掌心刻~~~~~（来生记得）[00:56.442]你眼中烟波滴落一滴墨 wo~~~[01:01.215]若佛说~~~~~（无牵无挂）[01:03.360]放下执着~~~~~（无相无色）[01:05.933]我怎能 波澜不惊 去附和[01:09.528][01:10.171]一想到你我就[01:12.153]wu~~~~~[01:13.837]恨情不寿 总于苦海囚[01:16.325]wu~~~~~[01:18.519]新翠徒留 落花影中游[01:21.102]wu~~~~~[01:23.370]相思无用 才笑山盟旧[01:25.936]wu~~~~~[01:29.507]谓我何求[01:31.805][01:43.123]种一万朵莲花[01:45.058]在众生中发芽[01:47.418]等红尘一万种解答[01:50.257][01:51.349]念珠落进 时间的泥沙[01:54.688]待 割舍诠释慈悲[01:58.638]的读法[02:00.004][02:00.552]前世迟来者~~~（擦肩而过）[02:03.599]掌心刻~~~~~（来生记得）[02:06.010]你眼中烟波滴落一滴墨 wo~~~[02:10.800]若佛说~~~~~（无牵无挂）[02:12.925]放下执着~~~~~（无相无色）[02:15.615]我怎能 波澜不惊 去附和[02:19.467][02:22.217]一想到你我就[02:24.044]wu~~~~~[02:25.732]恨情不寿 总于苦海囚[02:28.216]wu~~~~~[02:30.546]新翠徒留 落花影中游[02:33.043]wu~~~~~[02:35.342]相思无用 才笑山盟旧[02:37.935]wu~~~~~[02:41.533]谓我何求[02:44.528][03:20.812]混音：殇小谨[03:21.381]母带处理：殇小谨[03:21.973]和声：皎月[03:22.572]和声编写：皎月[03:23.181]文案：偏生梓归[03:23.765]古筝：紫格[03:24.329]古筝编写：紫格、Morri3on(喬凡三)[03:24.912]小提琴：大琴KoTo[03:25.503]小提琴编写：大琴KoTo[03:26.128]制作人：殇小谨[03:26.759]录音室：Hi Music Studio[03:27.343]混音室：Hi Music Studio[03:27.927]监制：李俊羽[03:28.531]出品：音阙诗听"
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            init(){
                this.cTime='00:00'
            },
            select(i){
                this.index = i;
                this.musicId=this.musicList[this.index].musicId;
                this.getMusicDetail()
            },
            next(){
                if(this.index+1===this.musicList.length){
                    this.index=0;
                }else{
                    this.index = this.index + 1;
                }
                this.musicId=this.musicList[this.index].musicId;
                this.getMusicDetail()

            },
            prev(){
                if(this.index===0){
                    this.index = this.musicList.length -1;
                }else{
                    this.index = this.index - 1;
                }
                this.musicId=this.musicList[this.index].musicId;
                this.getMusicDetail()
            },
            back() {
                history.back()
            },
            playMusic(){
                const music = this.$refs.player
                music.pause()

                this.play=!this.play
            },
            pauseMusic(){
                const music = this.$refs.player
                music.play()
                this.play=!this.play
            },
            async getMusicDetail() {
                let data = await getSources("/bear-scale/api/microMusic/getMusicDetail.json", {musicId:this.musicId});
                if (data.status === 0) {
                    this.init();
                    this.musicDetail = data.musicDetail;
                    this.begin();
                    // this.catalogStatus = false
                }else{
                    alert(data.msg)
                }
            },
            async getMusicList() {
                let data = await getSources("/bear-scale/api/microMusic/getMusicList.json", {});
                if (data.status === 0) {
                    this.musicList = data.musicList
                }else{
                    alert(data.msg)
                }
            },
            begin(){
                var conp = document.querySelector('.con-p')
                // 包裹歌词的元素容器
                lyrics.lyticsEnd(conp) // 重置对象
                lyrics.parse(this.musicDetail.lyrics, conp) // 解析歌词  this.lyrics 代表歌词数据
                lyrics.addcontent(conp) // 向元素容器中添加歌词内容
                lyrics.gundong(conp) // 歌词滚动函数

                const music = this.$refs.player  // 音频所在对象
                const musicBar = this.$refs.runbar  // 颜色进度条所在对象
                const musicWidth = this.$refs.runfatbar.offsetWidth // 底部进度条总宽

                // 获得音频加载完成可播放时的处理
                music.addEventListener('canplay', () => {
                    const musicTime = music.duration // 获得音频时长
                    const branch = Math.floor(musicTime / 60) // 计算音频分钟
                    const second = Math.floor(musicTime % 60) // 计算音频秒
                    if (branch < 10 && second < 10) { // 四种情况判断音频总时间
                        this.dTime = `0${branch}:0${second}`
                    } else if (branch < 10) {
                        this.dTime = `0${branch}:${second}`
                    } else if (second < 10) {
                        this.dTime = `${branch}:0${second}`
                    } else {
                        this.dTime = `${branch}:${second}`
                    }
                })
                // 获得音频正在播放时的处理
                music.addEventListener('timeupdate', () => {
                    const musicTime = music.duration // 获得音频时长
                    const stopTime = music.currentTime // 获得已播放的音频时长
                    musicBar.style.width = `${(stopTime / musicTime) * 100}%` // 计算进度条所在比例宽度
                    const branch = Math.floor(stopTime / 60) // 计算已播放的音频分钟
                    const second = Math.floor(stopTime % 60) // 计算已播放的音频秒
                    if (branch < 10 && second < 10) { // 四种情况判断显示音频以播放时间
                        this.cTime = `0${branch}:0${second}`
                    } else if (branch < 10) {
                        this.cTime = `0${branch}:${second}`
                    } else if (second < 10) {
                        this.cTime = `${branch}:0${second}`
                    } else {
                        this.cTime = `${branch}:${second}`
                    }

                    if(musicTime===stopTime){
                        this.next()
                    }
                })
                // music.addEventListener("playing", function(){
                //     console.log(`播放`)
                //     this.play=true
                // });
                // music.addEventListener("pause", function(){
                //     this.play=false
                // });
                // // 监听颜色进度条是否触摸拖动
                // musicBar.addEventListener('touchmove', (event) => {
                //     const events = event.targetTouches[0].pageX // 获得触摸拖动的距离
                //
                //
                //     musicBar.style.width = `${(events / musicWidth) * 100}%` // 计算进度条所在比例宽度
                //     music.pause() // 触摸拖动时停止播放
                // })
                //
                // // 监听颜色进度条是否触摸拖动结束
                // musicBar.addEventListener('touchend', () => {
                //     const touwidth = (musicBar.offsetWidth / musicWidth) // 计算进度条所在比例
                //     music.currentTime = music.duration * touwidth // 通过所在比例赋值给音频应在的播放时间
                //     music.play() // 根据播放时间开始播放
                //     this.play = true // 更改播放暂停按钮为播放
                // })
                //
                // // 这里顺便写的，适用于PC端。鼠标事件
                // musicBar.addEventListener('drag', (e) => {
                //     const events = e.pageX
                //     console.log(events)
                //     musicBar.style.width = `${(events / musicWidth) * 100}%`
                // })
                // musicBar.addEventListener('dragend', (e) => {
                //     const events = e.pageX
                //     musicBar.style.width = `${(events / musicWidth) * 100}%`
                //     this.playMusic()
                // })
            }

        },
        destroyed(){
            const music = this.$refs.player

            if (music != undefined && music != null) {
              music.removeEventListener('canplay', () => {
              });
              music.removeEventListener('timeupdate', () => {
              });
              music.removeEventListener('playing', () => {
              });
              music.removeEventListener('pause', () => {
              });
            }
        },
        mounted() {
            this.musicId = this.$route.query.musicId;
            // document.addEventListener('DOMContentLoaded', function () {
            //
            //     function audioAutoPlay() {
            //         var musicEle0 = document.getElementById('main-audio');
            //
            //         musicEle0.play();
            //
            //     }
            //
            //     audioAutoPlay();
            //
            // });

//--创建触摸监听，当浏览器打开页面时，触摸屏幕触发事件，进行音频播放
            document.addEventListener('touchstart', function () {
                function audioAutoPlay() {
                    var musicEle0 = document.getElementById('main-audio');
                    musicEle0.play();
                }
                audioAutoPlay();
            });
            this.getMusicDetail();
            this.getMusicList();

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/music.vue?763efbb3